module.exports = __webpack_public_path__ + "img/check-mark.37fb82fa.svg";